/**
 * Parses a search params string and returns a record of the known keys and their values.
 * @param searchParams - The search params string to parse.
 * @param knownKeys - The known keys to parse.
 * @returns A record of the known keys and their values.
 */
export function parseCognitoUrlParams(searchParams: string, knownKeys: string[]) {
  // Strip leading ?
  const raw = searchParams.startsWith('?') ? searchParams.slice(1) : searchParams;
  const result: Record<string, string> = {};

  // Find each key's position and extract greedily
  let remaining = raw;

  for (const key of knownKeys) {
    const prefix = `${key}=`;
    const idx = remaining.indexOf(prefix);
    if (idx === -1) continue;

    const valueStart = idx + prefix.length;
    // Value ends at the next "&knownKey=" (any known key), or end of string
    let valueEnd = remaining.length;
    for (const other of knownKeys) {
      if (other === key) continue;
      const boundary = remaining.indexOf(`&${other}=`, valueStart);
      if (boundary !== -1 && boundary < valueEnd) valueEnd = boundary;
    }
    const value = remaining.slice(valueStart, valueEnd);
    // Do not replace + with space — Cognito sends unencoded + in emails (e.g. user+tag@domain.com)
    // and neither code nor email parameters ever contain spaces, so the conversion is unnecessary
    result[key] = decodeURI(value).replace('&gt;', '>').replace('&lt;', '<');
    // Trim only this key's segment so later keys remain in remaining
    remaining = remaining.slice(0, idx) + (valueEnd < remaining.length ? remaining.slice(valueEnd) : '');
  }
  return result;
}
